// extracted by mini-css-extract-plugin
module.exports = {"loader":"faq-module--loader--2lIaG","bg":"faq-module--bg--2k7g-"};